module.exports = __webpack_public_path__ + "img/portfolio-01-670x479.0e75faca.jpg";